function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { nodeArray, attach, loopObject, offset } from 'meteora';
import GoogleMaps from '@meteora-digital/google-maps';
// const ajax = require('../functions/ajax');

document.addEventListener('DOMContentLoaded', function () {
  // All all map selectors here to only load google when we need it
  var locationsPage = document.querySelector('.js-locations');
  var locationsMap = document.querySelector('.js-locations--map');
  var locationsFilterHolder = document.querySelector('.locations__filters');
  var locationsMessage = document.querySelector('.js-locations--message');
  var locationsSelects = nodeArray(document.querySelectorAll('.js-locations--select'));
  var locationsSearches = nodeArray(document.querySelectorAll('.js-locations--search'));
  var locationsSidebar = document.querySelector('.js-locations--sidebar');
  var locationsFilter = {};
  var Sidebar = /*#__PURE__*/function () {
    function Sidebar(el) {
      _classCallCheck(this, Sidebar);
      if (el) this.el = el;
    }
    _createClass(Sidebar, [{
      key: "template",
      value: function template(location) {
        return "\n        <div class=\"locations__sidebar__item\">\n          <div class=\"row\">\n            <div class=\"column\">\n              ".concat(location.status ? "<h6 class=\"locations__sidebar__item__status\">".concat(location.status, "</h6>") : '', "\n              <h5 class=\"locations__sidebar__item__title\">").concat(location.title, "</h5>\n              ").concat(location.physical_address ? "\n                <h6 class=\"locations__sidebar__item__title\">Physical address</h6>\n                <p>".concat(location.physical_address, "</p>\n              ") : '', "\n              ").concat(location.phone ? "<a href=\"".concat(location.phone.Link, "\" class=\"locations__sidebar__item__contact\">").concat(location.phone.Title, "</a><br />") : '', "\n              ").concat(location.email ? "<a href=\"".concat(location.email.Link, "\" class=\"locations__sidebar__item__contact\">").concat(location.email.Title, "</a><br />") : '', "\n              ").concat(location.fax ? "<a href=\"".concat(location.fax.Link, "\" class=\"locations__sidebar__item__contact\">").concat(location.fax.Title, "</a><br />") : '', "\n              <a href=\"").concat(location.link, "\" class=\"locations__sidebar__item__link\">Read more</a>\n            </div>\n          </div>\n        </div>\n      ");
      }
    }, {
      key: "update",
      value: function update(locations) {
        var _this = this;
        if (this.el) {
          this.el.innerHTML = '';
          if (locations.length >= 1) {
            this.el.classList.add('js-active');
            locations.forEach(function (location) {
              return _this.el.innerHTML += _this.template(location.data);
            });
          } else {
            this.el.classList.remove('js-active');
          }
        } else {
          console.log('No element was passed into the constructor!');
        }
      }
    }]);
    return Sidebar;
  }();
  if (locationsPage) {
    GoogleMaps.Load('AIzaSyDh_1k9VyCpezJ_hKUy5rVPocpz50HvxBk');
    var scrollToMap = function scrollToMap() {
      window.ScrollControl.scrollTo(offset(locationsFilterHolder).y);
    };
    GoogleMaps.Render(function () {
      var sb = new Sidebar(locationsSidebar);
      var filteredLocations = window.winstoneLocations.data;
      filteredLocations.forEach(function (location) {
        location.position = {
          lat: parseFloat(location.latitude),
          lng: parseFloat(location.longitude)
        };
      });
      var map = GoogleMaps.Controller(locationsMap, {
        locations: filteredLocations,
        cluster: true,
        clusterSettings: {
          maxZoom: 15,
          enableRetinaIcons: true,
          styles: [{
            url: '/_resources/themes/mercury/source/images/maps/m1.png',
            width: 24,
            height: 36
          }]
        },
        icon: {
          fillColor: '#082157'
        }
      });

      // Get the map zoom level correct
      // attach(window, 'resize', () => {
      //   map.fitBounds((filteredLocations.length) ? filteredLocations : map.locations);
      //   if (map.map.zoom > 15) map.map.setZoom(15);
      // }, 500);

      // Create the infoWindow template
      map.infoTemplate(function (location) {
        return "\n          <div class=\"gm-info\">\n            ".concat(location.status ? "<h6 class=\"gm-info__status\">".concat(location.status, "</h6>") : '', "\n            <h4 class=\"gm-info__title\">").concat(location.title, "</h4>\n            <ul class=\"gm-info__details unstyled\">\n              <li class=\"gm-info__details__item\">\n                ").concat(location.phone ? "<a href=\"".concat(location.phone.Link, "\" class=\"gm-info__details__item__contact\">").concat(location.phone.Title, "</a><br />") : '', "\n                ").concat(location.email ? "<a href=\"".concat(location.email.Link, "\" class=\"gm-info__details__item__contact\">").concat(location.email.Title, "</a><br />") : '', "\n                ").concat(location.fax ? "<a href=\"".concat(location.fax.Link, "\" class=\"gm-info__details__item__contact\">").concat(location.fax.Title, "</a><br />") : '', "\n              </li>\n              ").concat(location.available_hours ? "\n                <li class=\"gm-info__details__item\">\n                  <h6>Available hours</h6>\n                  <p>".concat(location.available_hours, "</p>\n                </li>\n              ") : '', "\n\n              ").concat(location.physical_address ? "\n                <li class=\"gm-info__details__item\">\n                  <h6>Physical address</h6>\n                  <p>".concat(location.physical_address, "</p>\n                </li>\n              ") : '', "\n\n              <li class=\"gm-info__details__item\">\n                <a href=\"").concat(location.link, "\" class=\"gm-info__details__item__link\">Read more</a>\n              </li>\n            </ul>\n          </div>");
      });
      var applyFilter = function applyFilter() {
        scrollToMap();
        filteredLocations = [];
        locationsSelects.forEach(function (select) {
          return getInputValue(select);
        });
        locationsSearches.forEach(function (search) {
          return getInputValue(search);
        });
        for (var i = 0; i < map.locations.length; i++) {
          var include = true;
          for (var filter in locationsFilter) {
            if (typeof map.locations[i].data[filter] === 'string') {
              include = map.locations[i].data[filter].includes(locationsFilter[filter]);
            } else if (Array.isArray(map.locations[i].data[filter])) {
              include = map.locations[i].data[filter].includes(locationsFilter[filter]);
            } else {
              for (var key in map.locations[i].data[filter]) {
                include = map.locations[i].data[filter][locationsFilter[filter]] !== undefined;
                break;
              }
            }
            if (!include) break;
          }
          if (include) filteredLocations.push(map.locations[i]);
        }
        map.filterMarkers(filteredLocations);
        sb.update(filteredLocations.length === window.winstoneLocations.data.length ? [] : filteredLocations);
      };
      var fitBounds = function fitBounds() {
        if (filteredLocations.length === 0) {
          map.fitBounds(map.locations);
          locationsMessage.innerHTML = "Unfortunately there are no results found, please expand your search.";
          locationsMessage.classList.add('no-results');
        } else {
          if (map.map.zoom > 15) map.map.setZoom(15);
          locationsMessage.classList.remove('no-results');
        }
      };
      var getInputValue = function getInputValue(input) {
        var name = input.getAttribute('data-filter-name');
        if (input.value !== '' && name !== 'postcode') {
          locationsFilter[name] = input.value;
        } else if (locationsFilter[name]) {
          delete locationsFilter[name];
        } else if (name === 'postcode' && input.value !== '') {
          postcodeFinder.geocode({
            componentRestrictions: {
              country: 'NZ',
              postalCode: input.value
            }
          }, function (results, status) {
            if (status == 'OK') {
              locationsMessage.classList.remove('no-results');
              map.map.panTo(results[0].geometry.location);
              map.map.setZoom(11);
            } else {
              locationsMessage.innerHTML = "Unfortunately we cannot match that postcode, please change your search.";
              locationsMessage.classList.add('no-results');
            }
          });
        }
      };

      // Filtering
      locationsSelects.forEach(function (select) {
        select.addEventListener('change', function () {
          applyFilter();
          fitBounds();
        });
      });
      var postcodeFinder = new GoogleMaps.Geocoder();
      locationsSearches.forEach(function (search) {
        var name = search.getAttribute('data-filter-name');
        var timeout = null;
        search.addEventListener('keyup', function () {
          clearTimeout(timeout);
          timeout = setTimeout(function () {
            applyFilter();
            fitBounds();
          }, 500);
        });
      });

      // map.markers.forEach((marker) => {
      //   marker.addListener('click', () => scrollToMap());
      // });

      applyFilter();
    });
  }
  ;
});